module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "am-modal am-modal-alert",
    attrs: {
      "tabindex": "-1",
      "id": "my-alert"
    }
  }, [_c('div', {
    staticClass: "am-modal-dialog"
  }, [_c('div', {
    staticClass: "am-modal-bd"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccb170f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/alert.vue
// module id = 911
// module chunks = 2